import getEnvFromHostname from '../../utils/getEnvFromHostname';
import { PWA_VAPID_KEYS } from '../../config/constants';

const derivePublicVapidKey = (): string | undefined => {
  const env = getEnvFromHostname();
  switch (env) {
    case 'local':
      return PWA_VAPID_KEYS.local;
    case 'ue1dev1':
      return PWA_VAPID_KEYS.ue1dev1;
    case 'ue1dev2':
      return PWA_VAPID_KEYS.ue1dev2;
    case 'ue1live':
      return PWA_VAPID_KEYS.ue1live;
    default:
      return undefined;
  }
};

export default derivePublicVapidKey;
